export default __webpack_public_path__ + "static/media/img-38-alberich.1be17f22.jpg";